<template>
  <div class="c-modal c-modal--claim-details">



    <section class="c-modal__box c-modal--claim-details__box">



      <div class="c-modal__box__header t-modal-header">
        <h2 class="c-modal__box__header__title t-modal-header__text"
            v-if="type === 'approver'">{{ $t('web.claim_details_modal.approver_header') }}</h2>
        <h2 class="c-modal__box__header__title t-modal-header__text"
            v-if="type === 'submitter'">{{ $t('web.claim_details_modal.submitter_header') }}</h2>
        <div class="c-modal__box__header__close">
          <button
            :disabled = "processingForm"
            @click    = "close"
            class     = "c-modal__box__header__close__button t-modal-header__close"
          >
            <i class="fa fa-close"></i>
          </button>
        </div>
      </div>



      <div class="c-modal__box__content">



        <div class="c-modal--claim-details__headline" v-if="type === 'approver'">
          <h1 class="c-modal--claim-details__headline__claim-number">{{ $t('web.claim_details_modal.claim_number', {claim_number: claim.record_number}) }}</h1>
          <div class="c-modal--claim-details__headline__claim-status">
            <span class="c-status" v-bind:class="claimStatusClass(claim)">{{ $t(CLAIM_STATUS_TRANSLATION[claim.status]) }}</span>
          </div>
        </div>

        <div v-else class="c-modal--claim-details__headline c-modal--claim-details__headline--submitter">
          <h1 class="c-modal--claim-details__headline__claim-number">{{ $t('web.claim_details_modal.claim_number', {claim_number: claim.record_number}) }}</h1>
          <div class="c-modal--claim-details__headline__claim-status">
            <span class="c-status" v-bind:class="claimStatusClass(claim)">{{ $t(CLAIM_STATUS_TRANSLATION[claim.status]) }}</span>
          </div>
        </div>



        <div class="c-modal--claim-details__overview"
             :class="[{ 'c-modal--claim-details__overview--submitter': type === 'submitter' }]">

          <dl class="c-modal--claim-details__overview__dl">
            <dt class="c-modal--claim-details__overview__dl__dt">{{ $t('web.claim_details_modal.claim_submitted') }}</dt>
            <dd class="c-modal--claim-details__overview__dl__dd">{{ claim.created_at }}</dd>
          </dl>

          <dl class="c-modal--claim-details__overview__dl">
            <dt class="c-modal--claim-details__overview__dl__dt">{{ $t('web.claim_details_modal.claim_form_name') }}</dt>
            <dd class="c-modal--claim-details__overview__dl__dd">{{ claim.form_name }}</dd>
          </dl>

          <dl class="c-modal--claim-details__overview__dl">
            <dt class="c-modal--claim-details__overview__dl__dt">
              {{ type === 'approver' ? $t('web.claim_details_modal.claim_submitter') : $t('web.claim_details_modal.claim_approver') }}
            </dt>
            <dd class="c-modal--claim-details__overview__dl__dd">
              <span>{{ type === 'approver' ? claim.participant_name : claim.approver_name}}</span>
              <button class="c-modal--claim-details__overview--submitter__toggle-notes"
                      v-if="type === 'submitter'"
                      @click="toggleNotes()">{{ notesMessage }}
              </button>
            </dd>
          </dl>

        </div>



        <div class="c-modal--claim-details__submitter-view-notes"
             v-if="(type === 'submitter')" v-bind:class="[{ 'is-visible': showNotes }, { 'is-hidden': !showNotes }]">

          <div class="c-modal--claim-details__submitter-view-notes__bubble"
               v-if="claim.approver_notes"
               v-html="formatNotes">
          </div>

          <div class="c-modal--claim-details__submitter-view-notes__bubble" v-else>
            <p class="c-modal--claim-details__notes-paragraph u-italic">{{ $t('web.claim_details_modal.no_approver_notes') }}</p>
          </div>

        </div>


        <div class="c-modal--claim-details__details" v-if="claim.field_defs" ref="formDef">
          <fieldset v-for="(field,index) in claim.field_defs" class="o-fieldset c-modal--claim-details__details__fieldset" :key="index">
              <component :is="getFieldComponentType(field)"
                         :field="field" :errors="errors" :name="field.name"
                         :template="type === 'submitter' && claim.status === CLAIM_STATUS.UPDATE_NEEDED ? 'edit' : 'detail'"
                         v-model="claim.field_values[field.name]"
                         labelClass="c-modal--claim-details__details__fieldset__label"></component>
               <div v-if="errors[field.name]"
                    class="c-validation t-alert-danger">
                    {{ errors[field.name] }}
               </div>
          </fieldset>
        </div>



        <div v-if="type === 'approver'" class="c-modal--claim-details__approver-view-notes">
          <h2 class="c-modal--claim-details__approver-view-notes__header">{{ $t('web.claim_details_modal.claim_notes_label') }}</h2>

          <p class="c-modal--claim-details__approver-view-notes__desc" v-if="claim.status === CLAIM_STATUS.PENDING">
            {{ $t('web.claim_details_modal.claim_notes_hint') }}
          </p>

          <textarea v-if="claim.status === CLAIM_STATUS.PENDING" v-model="claim.approver_notes"
          class="o-textarea c-modal--claim-details__approver-view-notes__textarea"></textarea>

          <div v-if="(claim.approver_notes && claim.status !== CLAIM_STATUS.PENDING)" class="c-modal--claim-details__approver-view-notes__text" v-html="formatNotes"></div>
        </div>



      </div>


      <div class="c-modal__box__actions"  v-if="type === 'approver' && claim.status === CLAIM_STATUS.PENDING">
        <button class="c-modal__box__actions__button t-button-info" :disabled="processingForm"
                @click="approverUpdate(CLAIM_STATUS.DECLINED)">
            {{ $t('web.claim_details_modal.decline_claim_button') }}
        </button>

        <button class="c-modal__box__actions__button t-button-danger" :disabled="processingForm"
                @click="approverUpdate(CLAIM_STATUS.UPDATE_NEEDED)">
            {{ $t('web.claim_details_modal.update_needed_button') }}
        </button>

        <button class="c-modal__box__actions__button t-button-success" :disabled="processingForm"
                @click="approverUpdate(CLAIM_STATUS.APPROVED)">
            {{ $t('web.claim_details_modal.approve_claim_button') }}
        </button>
      </div>


      <div class="c-modal__box__actions c-modal--claim-details__box__actions"  v-if="type === 'submitter' && claim.status === CLAIM_STATUS.UPDATE_NEEDED">

        <div class="c-modal--claim-details__box__actions__right">
          <button class="c-modal__box__actions__button t-button-plain" ref="cancelButton"
                  :disabled="processingForm"
                  @click="cancel">{{ $t('web.claim_details_modal.cancel_submission_button') }}
          </button>

          <button class="c-modal__box__actions__button c-modal--claim-details__submitter-submit-button t-button-primary"        ref="submitButton"
                  :disabled="processingForm"
                  @click="update">{{ $t('web.claim_details_modal.submit_updates_button') }}
          </button>
        </div>

        <div class="c-modal--claim-details__box__actions__left">
          <button class="c-modal__box__actions__button t-button-danger" ref="withdrawButton"
                  :disabled="processingForm"
                  @click="withdraw">{{ $t('web.claim_details_modal.withdraw_claim_button') }}
          </button>
        </div>

      </div>



    </section>



    <div class="c-modal__overlay"></div>



  </div>
</template>





<script>
import $ from 'jquery'
import _ from 'lodash'
import API from '@/services'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import FieldCurrency from './fields/FieldCurrency'
import FieldVarchar from './fields/FieldVarchar'
import FieldEmail from './fields/FieldEmail'
import FieldDate from './fields/FieldDate'
import FieldDecimal from './fields/FieldDecimal'
import FieldPercent from './fields/FieldPercent'
import FieldInteger from './fields/FieldInteger'
import FieldBool from './fields/FieldBool'
import FieldEnum from './fields/FieldEnum'
import FieldFileUpload from './fields/FieldFileUpload'
import util from '@/functions'
import { CLAIM_STATUS, CLAIM_STATUS_TRANSLATION } from '@/enums'

export default {
  data () {
    return {
      errors: {},
      claimData: {},
      toastWait: 5000,
      processingForm: false,
      showNotes: false,
      CLAIM_STATUS,
      CLAIM_STATUS_TRANSLATION
    }
  },

  components: {
    fieldCurrency: FieldCurrency,
    fieldVarchar: FieldVarchar,
    fieldEmail: FieldEmail,
    fieldDate: FieldDate,
    fieldDecimal: FieldDecimal,
    fieldInteger: FieldInteger,
    fieldPercent: FieldPercent,
    fieldBool: FieldBool,
    fieldEnum: FieldEnum,
    fieldFileUpload: FieldFileUpload
  },

  mounted () {
    if (this.type === 'submitter' && this.claim.status === CLAIM_STATUS.UPDATE_NEEDED) {
      this.showNotes = true
    }
  },

  computed: {
    ...mapGetters({
      claim: 'claimModalData',
      type: 'claimModalType'
    }),

    notesMessage: function () {
      return (this.showNotes)
        ? this.$t('web.claim_details_modal.hide_approver_notes')
        : this.$t('web.claim_details_modal.show_approver_notes')
    },

    formatNotes: function () {
      let text = document.createTextNode(this.claim.approver_notes)
      let div = document.createElement('div')
      div.appendChild(text)
      return '<p class="c-modal--claim-details__notes-paragraph">' +
      div.innerHTML
      .replace(/(?:\n\s*\n)/g, '</p><p class="c-modal--claim-details__notes-paragraph">')
      .replace(/(?:\n\r\|\n|\r)/g, '<br>') +
      '</p>'
    }

  },

  methods: {
    ...mapActions([
      'WITHDRAW_CLAIM',
      'UPDATE_SUBMITTER_CLAIM'
    ]),

    ...mapMutations([
      'UPDATE_CLAIM_MODAL_MESSAGE',
      'UPDATE_APPROVER_CLAIMS'
    ]),

    getFieldComponentType (field) {
      return 'field-' + _.replace(field.type, '_', '-')
    },

    close () {
      this.showNotes = false
      util.closeModals()
      this.errors = {}
      _.each(this.claim.field_defs, (field, i) => {
        var input = $('[name="' + field.name + '"] input')
        input.removeClass('is-not-valid')
      })
    },

    withdraw () {
      this.processingForm = true
      this.WITHDRAW_CLAIM(this.claim.id)
        .then((resp) => {
          this.closeAndShowToastMessage(this.$t('web.claim_details_modal.claim_withdrawn'))
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            this.closeAndShowToastMessage(this.$t('web.claim_details_modal.claim_withdrawal_failed'))
          }
          this.close()
          this.processingForm = false
        })
    },

    update () {
      let validation = util.validateFields(this.$el, this.claim.field_defs, this.claim.field_values)
      this.errors = validation.errors

      _.each(this.claim.field_defs, (field, i) => {
        var input = $(this.$el).find('[name="' + field.name + '"] input')
        if (this.errors[field.name]) {
          input.addClass('is-not-valid')
        } else {
          input.removeClass('is-not-valid')
        }
      })

      if (validation.valid) {
        this.processingForm = true
        let formData = new FormData()
        let hasFiles = false

        formData.append('fields', JSON.stringify(util.getDataToBeSaved(this.claim.field_defs, this.claim.field_values)))
        formData.append('form_id', this.claim.form_id)
        formData.append('id', this.claim.id)

        _.each(this.claim.field_defs, (field, i) => {
          if (field.type === 'file_upload') {
            hasFiles = true
          }
        })
        if (hasFiles) {
          // validate the form first
          API.postAuthenticated('claim-forms/validate', formData)
          .then((response) => {
            this.sendFormData(formData)
          })
          .catch(this.processAPIError)
        } else {
          this.sendFormData(formData)
        }
      } else {
        this.processingForm = false
      }
    },

    sendFormData (formData) {
      _.each(this.claim.field_defs, (field, i) => {
        if (field.type === 'file_upload') {
          let files = this.$children[i].$refs.dropzone.getAddedFiles()
          _.each(files, (file) => {
            formData.append(field.name + '[]', file)
          })
        }
      })
      this.claimData.id = this.claim.id
      this.claimData.data = formData

      this.UPDATE_SUBMITTER_CLAIM(this.claimData)
        .then(resp => {
          this.closeAndShowToastMessage(this.$t('web.claim_details_modal.submitter_updated_claim'))
        })
        .catch(this.processAPIError)
    },

    processAPIError (error) {
      this.processingForm = false
      if (error.response && error.response.status === 400) {
        var messages = {}
        for (var field in error.response.data.errors) {
          $(this.$el).find('[name="' + field + '"] input').addClass('is-not-valid')
          messages[field] = error.response.data.errors[field][0]
        }
        this.errors = messages
      } else {
        this.closeAndShowToastMessage(this.$t('web.claim_details_modal.submitter_failed_to_update'))
      }
    },

    cancel () {
      this.close()
    },

    approverUpdate (status) {
      this.processingForm = true
      let formData = {}
      formData.approval_status = status
      formData.approver_notes = this.claim.approver_notes
      API.putAuthenticated('claims/approver/' + this.claim.id, formData)
          .then((response) => {
            this.UPDATE_APPROVER_CLAIMS(response.data)
            this.closeAndShowToastMessage(this.$t('web.claim_details_modal.approver_updated_claim'))
          })
          .catch(() => {
            this.closeAndShowToastMessage(this.$t('web.claim_details_modal.approver_failed_to_update'))
          })
    },

    closeAndShowToastMessage (message) {
      this.processingForm = false
      this.UPDATE_CLAIM_MODAL_MESSAGE(message)
      setTimeout(() => {
        this.UPDATE_CLAIM_MODAL_MESSAGE(null)
      }, this.toastWait)
      this.close()
    },

    claimStatusClass (claim) {
      return {
        't-alert-success': claim.status === CLAIM_STATUS.APPROVED,
        't-alert-danger': claim.status === CLAIM_STATUS.UPDATE_NEEDED,
        't-alert-warning': claim.status === CLAIM_STATUS.PENDING,
        't-alert-info': claim.status === CLAIM_STATUS.DECLINED
      }
    },

    toggleNotes () {
      this.showNotes = !this.showNotes
    }

  }
}
</script>


<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// ClaimDetailsModal.vue?de5e9df4